import { render, staticRenderFns } from "./table-footer-indicator.vue?vue&type=template&id=3dad2c7b&"
import script from "./table-footer-indicator.vue?vue&type=script&lang=js&"
export * from "./table-footer-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports